import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Btn, Reveal } from "@/components/Elements";
import { STEPS, CALENDLY } from "@/data/content";

export default function LoanProcess() {
  return (
    <div>
      <Seo
        title="The Loan Process | Step-by-Step | Family First Mortgage USA"
        description="A transparent, step-by-step guide to the mortgage process with Joe Spellman — from your first call to closing day in as few as 9–16 days."
      />
      <PageHeader
        eyebrow="How It Works"
        line1="Your Path to"
        line2="Homeownership"
        sub="A transparent, step-by-step guide to what happens from your first call to closing day."
      />

      <section className="bg-cream py-20 md:py-28" data-testid="steps-list">
        <div className="wrap">
          <div className="overflow-hidden rounded-3xl border border-line bg-white">
            {STEPS.map((s, i) => (
              <Reveal
                as="article"
                key={s.num}
                delay={(i % 2) * 80}
                className={`grid gap-8 p-8 md:p-12 lg:grid-cols-[300px_1fr_1fr] lg:gap-12 ${
                  i > 0 ? "border-t border-line" : ""
                }`}
                data-testid={`step-row-${i + 1}`}
              >
                <div>
                  <span className="font-serif text-6xl font-normal italic text-goldpale">{s.num}</span>
                  <h2 className="mt-3 font-serif text-xl font-bold text-navy">{s.name}</h2>
                  {s.timing && (
                    <p className="mt-2 text-[11px] font-medium uppercase tracking-[0.18em] text-gold">{s.timing}</p>
                  )}
                </div>
                <p className="text-sm leading-relaxed text-ink sm:text-base">{s.desc}</p>
                <ul className="space-y-2.5">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex gap-3 text-sm text-ink">
                      <span className="font-medium text-gold" aria-hidden="true">
                        –
                      </span>
                      {b}
                    </li>
                  ))}
                </ul>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20 text-center" data-testid="process-cta">
        <div className="wrap">
          <Btn variant="gold" href={CALENDLY} external testId="process-schedule-consultation">
            Schedule a Consultation
          </Btn>
        </div>
      </section>
    </div>
  );
}
